import { Radio, RadioGroup, Switch } from '@blueprintjs/core'
import * as React from 'react'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import ConfigureOptions from '../ConfigureOptions'
import { InputLabel } from '../../../../../components/inputs/InputLabel'
import { UprightStyle } from '../../../../../types'
import { templateStyles } from './templateStyles'

const styles: UprightStyle = {
  radioGroupContainer: { marginTop: 5 }
}

export const Form = ({ input, onFormPreviewChange, index }) => {
  const { props } = input
  return (
    <div>
      <InputLabel
        title={props.label}
        required={props.required && isEmpty(props.value)}
        requiredLabelStyle={templateStyles.requiredLabel}
        requiredLabelIconName={props.requiredLabelIconName}
      >
        <div style={styles.radioGroupContainer}>
          <RadioGroup
            onChange={v => onFormPreviewChange(index, v.currentTarget.value)}
            inline={props.inline}
            selectedValue={props.value}
          >
            {(props.options || []).map((opt: any, i: number) => {
              // eslint-disable-next-line react/no-array-index-key
              return <Radio key={i} label={opt.key} value={opt.value} />
            })}
          </RadioGroup>
          {props.helpText && (
            <Help>
              <div>{props.helpText}</div>
            </Help>
          )}
        </div>
      </InputLabel>
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.props
  return (
    <div>
      <Switch checked={inputProps.inline} label="Inline" onChange={() => onChange('inline', !inputProps.inline)} />
      <ConfigureOptions input={input} onChange={onChange} />
    </div>
  )
}
